
import Swiper from 'swiper/bundle';
import 'swiper/css/bundle';
window.Swiper = Swiper;
import NiceSelect from "nice-select2";
import IMask from 'imask';
import { Fancybox } from "@fancyapps/ui";
import "@fancyapps/ui/dist/fancybox/fancybox.css";

import  RangeSlider  from 'range-slider-input';
import 'range-slider-input/dist/style.css';
import { info } from 'autoprefixer';
window.NiceSelect = NiceSelect;



function calculateLoan(carPrice, initialPayment, loanTermMonths) {
  const carPriceClear = String(carPrice).replace(/\D/g, '');
    
    // Дальше преобразуем обратно в число
    const numericCarPrice = parseInt(carPriceClear) || 0;
    console.log(numericCarPrice)

    const interestRate = window.crеditRate; // Годовая ставка 7.2%
    const loanAmount = numericCarPrice - initialPayment; // Сумма кредита
    
    // Месячная процентная ставка
    const monthlyRate = interestRate / 12 / 100;
  
    // Расчёт аннуитетного платежа
    const annuityPayment = loanAmount * 
        (monthlyRate * Math.pow(1 + monthlyRate, loanTermMonths)) / 
        (Math.pow(1 + monthlyRate, loanTermMonths) - 1);
    
    // Общая сумма к возврату
    const totalPayment = annuityPayment * loanTermMonths;
    
    // Переплата по кредиту
    const overpayment = totalPayment - loanAmount;
    
    return {
        monthlyPayment: Math.round(annuityPayment), // Ежемесячный платёж (округлённый)
        totalPayment: Math.round(totalPayment),     // Общая сумма выплат
        overpayment: Math.round(overpayment)        // Переплата
    };
}



function formatPrice(price) {
    return Number(price).toLocaleString('ru-RU', {
        maximumFractionDigits: 0,
        useGrouping: true
    }).replace(/,/g, ' ');
}

function returnOnlyNumbers(string) {
    const clearString = String(string).replace(/\D/g, '');
    const numeric = parseInt(clearString) || 0;
    return numeric;
}


document.addEventListener('DOMContentLoaded', function() {
//

document.addEventListener('click', function(e) {



    if (e.target.classList.contains('open__cities')) {
        const cities = document.querySelector('.cities__list');
        cities.classList.toggle('active');
        e.stopPropagation(); // Останавливаем всплытие события
        return;
    }


    document.querySelectorAll('.cities__list').forEach(ctx => {
        ctx.classList.remove('active');

    })



})





})

document.addEventListener('DOMContentLoaded', function () {
    const swiperContainer = document.querySelector('.swiper');
  
    if (swiperContainer) {
        // const swiper = new Swiper(swiperContainer, {
        //     // ваши параметры
        // });
    

        const swiper = new Swiper(swiperContainer, {
            // Ваши настройки Swiper
            loop: true,
            slidesPerView: 1,
            speed: 400,
            autoplay: {
                delay: 5000,
              },
            pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
        });




    } 






});


 document.addEventListener("DOMContentLoaded", () => {


// Переопределяем метод
NiceSelect.prototype._onSearchChanged = function(e) {
  var open = this.dropdown.classList.contains("open");
  var text = e.target.value;
  text = text.toLowerCase();

  if (text === "") {
    this.options.forEach(function(item) {
      item.element.style.display = "";
    });
    return;
  }

  if (!open) return;

  var matchReg = new RegExp(text);
  
  // Получаем оригинальный select элемент
  var originalSelect = this.el;
  
  this.options.forEach(function(item) {
    // Находим соответствующий option в оригинальном select
    var optionValue = item.element.getAttribute('data-value');
    var originalOption = originalSelect.querySelector('option[value="' + optionValue + '"]');
    
    // Получаем текст и русское название
    var optionText = item.data.text.toLowerCase();
    var rusName = originalOption ? (originalOption.getAttribute('data-rusname') || '').toLowerCase() : '';
    
    // Проверяем совпадение
    var matched = matchReg.test(optionText) || (rusName && matchReg.test(rusName));
    item.element.style.display = matched ? "" : "none";
  });

  // Удаляем класс focus у всех элементов
  this.dropdown.querySelectorAll(".focus").forEach(function(item) {
    item.classList.remove("focus");
  });

  var firstEl = this._findNext(null);
  if (firstEl) firstEl.classList.add("focus");
};





  const brandSelect = document.querySelector(".a-select");
    const modelSelect = document.querySelector(".b-select");
    const fuelTypeSelect = document.querySelector(".c-select");
    const tradeIn = document.querySelector('.cat-select');

    if (tradeIn) {

const years = document.querySelector('.year-select');      
const userModels = document.querySelector('.user__model');      
const originalOnSearchChanged = NiceSelect.prototype._onSearchChanged;


  

    const nicetradein = new NiceSelect(tradeIn, {
    searchable: true,
    placeholder: "Марка вашего авто",
    searchtext: "Введите название марки",
    selectedtext: "Выбрано",
 
});

    const year = new NiceSelect(years, {
    searchable: true,
    placeholder: "Год вашего авто",
    searchtext: "Введите год",
    selectedtext: "Выбрано",
 
});
    const userModel = new NiceSelect(userModels, {
    searchable: true,
    placeholder: "Модель вашего авто",
    searchtext: "Введите название модели",
    selectedtext: "Выбрано",
 
});

let abortControllerUser = null;
        tradeIn.addEventListener('change', async function() {
            const brandId = this.value;
             const model = document.querySelector('.user__model');
             model.value = null;
            if (!brandId) {
                userModel.update([]);
                userModel.disable();
                return;
            }

  if (abortControllerUser) {
        abortControllerUser.abort();
    }
    abortControllerUser = new AbortController();


            try {
                // Показываем загрузку
                userModel.update([{ value: '', text: 'Загрузка...' }]);
                userModel.disable();

                // Формируем FormData для POST-запроса
                const formData = new FormData();
                formData.append('brand_id', brandId);

                // Отправляем POST-запрос
                const response = await fetch('/get-user-models-by-brand-id', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest', // Для Laravel (проверка isXmlHttpRequest)
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    }
                });

                if (!response.ok) {
                    throw new Error('Ошибка сервера');
                }

                const models = await response.json();
        
                 // Формируем опции для моделей
                const options = models.models.map(model => ({
                    value: model.id,
                    text: model.name,
                    rusname: model.rusname
                }));
                console.log(userModel)
                      console.log(options)  
       userModels.innerHTML = '';
    const emptyOption = document.createElement('option');
    emptyOption.value = '';
    emptyOption.textContent = 'Модель';
  userModels.appendChild(emptyOption);

    options.forEach(opt => {
  const option = document.createElement('option');
  option.value = opt.value;
  option.textContent = opt.text;
  option.dataset.rusname = opt.rusname;
  userModels.appendChild(option);
});   

               
                // Обновляем селект
                
                userModel.update();
                userModel.enable();
                
           
            } catch (error) {
                console.error('Ошибка:', error);
                userModel.update([{ value: '', text: 'Ошибка загрузки' }]);
            }
        });

const yearSearchInput = document.querySelector('.year-select input');
if (yearSearchInput) {
  yearSearchInput.addEventListener('input', function(e) {
    // Оставляем только цифры
    this.value = this.value.replace(/[^\d]/g, '');
  });
  
  // Можно также добавить ограничение по длине (например, 4 цифры для года)
  yearSearchInput.addEventListener('keypress', function(e) {
    if (this.value.length >= 4) {
      e.preventDefault();
    }
  });
}



    }// end of tradein



    if (brandSelect && modelSelect) {
        const niceBrand = new NiceSelect(brandSelect, {
            searchable: true,
            placeholder: "Марка",
            searchtext: "Введите название марки",
            selectedtext: "Выбрано",
             });




        const niceModel = new NiceSelect(modelSelect, {
            searchable: true,
            placeholder: "Модель",
            searchtext: "Введите название модели",
            selectedtext: "Выбрано",
            // disabled: true
        });
let abortController = null;
        brandSelect.addEventListener('change', async function() {
            const brandId = this.value;
             const model = document.querySelector('.b-select');
             model.value = null;
            if (!brandId) {
                niceModel.update([]);
                niceModel.disable();
                return;
            }

  if (abortController) {
        abortController.abort();
    }
    abortController = new AbortController();


            try {
                // Показываем загрузку
                niceModel.update([{ value: '', text: 'Загрузка...' }]);
                niceModel.disable();

                // Формируем FormData для POST-запроса
                const formData = new FormData();
                formData.append('brand_id', brandId);

                // Отправляем POST-запрос
                const response = await fetch('/get-models-by-brand-id', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest', // Для Laravel (проверка isXmlHttpRequest)
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    }
                });

                if (!response.ok) {
                    throw new Error('Ошибка сервера');
                }

                const models = await response.json();
                // Формируем опции для моделей
                const options = models.models.map(model => ({
                    value: model.model,
                    text: model.model,
                  }));

    const totalModels = document.querySelector('.filter__count');
    if (totalModels) {
           totalModels.innerText = models.total;
    }
 
    modelSelect.innerHTML = '';
    const emptyOption = document.createElement('option');
    emptyOption.value = '';
    emptyOption.textContent = 'Модель';
  modelSelect.appendChild(emptyOption);

    options.forEach(opt => {
  const option = document.createElement('option');
  option.value = opt.value;
  option.textContent = opt.text;
  modelSelect.appendChild(option);
});   

               
                // Обновляем селект
                
                niceModel.update();
                niceModel.enable();
                
           
            } catch (error) {
                console.error('Ошибка:', error);
                niceModel.update([{ value: '', text: 'Ошибка загрузки' }]);
            }
        });

    }

    if (fuelTypeSelect) {
            const niceFuelType = new NiceSelect(fuelTypeSelect, {
            searchable: false,
            placeholder: "Двигатель",
            // searchtext: "Введите название марки",
            selectedtext: "Выбрано"
        });

          const bodyTypeSelect = document.querySelector(".d-select");
             const bodySelect = new NiceSelect(bodyTypeSelect, {
            searchable: false,
            placeholder: "Кузов",
            // searchtext: "Введите название марки",
            selectedtext: "Выбрано"
        });
    const driveSelectType = document.querySelector(".e-select");
             const driveSelect = new NiceSelect(driveSelectType, {
            searchable: false,
            placeholder: "Привод",
            // searchtext: "Введите название марки",
            selectedtext: "Выбрано"
        });
           const transmSelectType = document.querySelector(".f-select");
             const transmSelect = new NiceSelect(transmSelectType, {
            searchable: false,
            placeholder: "Коробка",
            // searchtext: "Введите название марки",
            selectedtext: "Выбрано"
        });

   const engVolumeTypeFrom = document.querySelector(".g-select");
             const engVolumeSelectFrom = new NiceSelect(engVolumeTypeFrom, {
            searchable: false,
            placeholder: "Объем от",
            // searchtext: "Введите название марки",
            selectedtext: "Выбрано"
        });
   const engVolumeTypeTo = document.querySelector(".h-select");
             const engVolumeSelectTo = new NiceSelect(engVolumeTypeTo, {
            searchable: false,
            placeholder: "Объем до",
            // searchtext: "Введите название марки",
            selectedtext: "Выбрано"
        });

          const yearFromType = document.querySelector(".i-select");
             const yaerFromSelect = new NiceSelect(yearFromType, {
            searchable: false,
            placeholder: "Год от",
            // searchtext: "Введите название марки",
            selectedtext: "Выбрано"
        });
           const yearToType = document.querySelector(".j-select");
             const yaerToSelect = new NiceSelect(yearToType, {
            searchable: false,
            placeholder: "Год до",
            // searchtext: "Введите название марки",
            selectedtext: "Выбрано"
        });

const openFilter = document.querySelector('.open__filter');
openFilter.addEventListener('click', function(){
const hiddenBlocks = document.querySelectorAll('.filter-hide');
hiddenBlocks.forEach(container => {
    container.classList.toggle('active')

})
});

function updateCurrentPage() {
     const currentPage = document.querySelector('input[name="page"]');
     currentPage.value = 1;

}

const selects = document.querySelectorAll('select[class$="-select"]');

// Добавляем обработчик change для каждого
selects.forEach(select => {
    select.addEventListener('change', function() {
        updateCurrentPage();
    const currentPage = document.querySelector('input[name="page"]');
    const page = currentPage.value;


    //    loadCars()
       debouncedLoadCars()
    });
});
 }

const formFilter = document.querySelector('.filter-form');

if (formFilter) {
    
    formFilter.addEventListener('submit', (e)=> {
    e.preventDefault();
     debouncedLoadCars()

    })




}


 //Окончание обработки на странице catalog
    //Окончание обработки на странице catalog
    //Окончание обработки на странице catalog
    //Окончание обработки на странице catalog
    //Окончание обработки на странице catalog
    //Окончание обработки на странице catalog


function debounce(func, delay) {
    let timeout;
    return function() {
        const context = this;
        const args = arguments;
        clearTimeout(timeout);
        timeout = setTimeout(() => func.apply(context, args), delay);
    };
}

const debouncedLoadCars = debounce(loadCars, 1000);

     async function loadCars() {

            const model = document.querySelector('.b-select').value;
    const form = document.querySelector('.filter-form');
     const formData = new FormData(form);     
    formData.append('model',model) 
    
        toggleLoader(true)

  try {
              
         
                const container = document.querySelector('.filter__output');
                const containerPgination = document.querySelector('.filter__output-pagination');

                container.innerHTML = '';
                containerPgination.innerHTML = '';
        
                const response = await fetch('/get-cars', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest', // Для Laravel (проверка isXmlHttpRequest)
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    }
                });

   

                  const models = await response.json();
                   toggleLoader(false)
container.innerHTML = models.html;
containerPgination.innerHTML = models.pagination_html;
setupPaginationListener();
    const totalModels = document.querySelector('.filter__count');
    totalModels.textContent =models.total;
                changeCarsImages();
                if (models.html == '') {
                    const notFound = document.createElement('div')
                    const textnode = document.createTextNode("Извините, автомобилей, соответствующих заданным параметрам, не найдено");
                    notFound.append(textnode);
                    container.append(notFound)
                }
                
                if (!response.ok) {
                    throw new Error('Ошибка сервера');
                }

               
                
           
            } catch (error) {
                console.error('Ошибка:', error);
             
            }


}


const paginatorPages = document.querySelectorAll('.pagination .page-link');


function toggleLoader(show) {
  document.querySelector('.loader').style.display = show ? 'block' : 'none';
}


function setupPaginationListener() {
 
    const paginationContainer = document.querySelector('.filter__output-pagination'); 
  
    if (!paginationContainer) return;
    
    // Вешаем обработчик на контейнер
    paginationContainer.addEventListener('click', function(e) {
        // Проверяем, был ли клик по элементу пагинации
        const paginatorLink = e.target.closest('.page-link:not(.disabled)');
           console.log(paginatorLink)
        if (!paginatorLink) return;
        
        e.preventDefault();
        
        // Получаем номер страницы
        const page = paginatorLink.textContent.trim();
    
            const currentPage = document.querySelector('input[name="page"]');
    currentPage.value = page;
   
        // Если нужно получить URL из ссылки
        const url = paginatorLink.href;
 
        debouncedLoadCars()
        // loadCars();
    
    });
}


 changeCarsImages();

function changeCarsImages() {

const carContainers = document.querySelectorAll('.car__item');
    

    if (carContainers) {
        
   

    carContainers.forEach(container => {
        const mainImage = container.querySelector('.car__item-image img');
        const thumbnails = container.querySelectorAll('.nav-items li');
        
        thumbnails.forEach(thumb => {
            thumb.addEventListener('mouseenter', function() {
                const newSrc = this.getAttribute('data-src');
                
                // Удаляем active класс у всех миниатюр в этом контейнере
                thumbnails.forEach(t => t.classList.remove('active'));
                // Добавляем текущему
                this.classList.add('active');
                
                // Плавная смена
                // mainImage.style.opacity = '0';
                setTimeout(() => {
                    mainImage.src = newSrc;
                    mainImage.style.opacity = '1';
                }, 150);
            });

            thumb.addEventListener('click',()=> {
                const parent = thumb.closest('.car__item');
                const link = parent.querySelector('.car__item-show').getAttribute('href');
                window.location.href = link;
     
            });

        });
    });
 }
}



const elements = document.querySelectorAll('input[name="phone"]');

if (elements.length) {



const maskOptions = {
  mask: '+{7} (#00) 000-00-00',
  placeholderChar: '_',
 lazy: false,
 definitions: {
    '#': /[49]/
  },
 
};
let mask = '';
for (let i = 0; i < elements.length; i++) {
  // Инициализация маски для элемента
  const mask = IMask(elements[i], maskOptions);
  
  // Добавление слушателя события focus
  elements[i].addEventListener('focus', function() {

    // Дополнительные действия при фокусе
    // Например, можно выделить поле ввода:
//  mask.updateCursor(7);

  });
}
// const mask = IMask(element, maskOptions);
}



function initCustomScrollbar(list) {
  const track = document.createElement('div');
  track.className = 'scrollbar-track';
 
  const thumb = document.createElement('div');
  thumb.className = 'scrollbar-thumb';
//   track.className = 'scrollbar-thumb';
  list.appendChild(thumb);
  
  list.appendChild(track);


  // Логика перемещения скроллбара
  list.addEventListener('scroll', () => {
    //    track.style.height = 500;
    const thumbHeight = (list.clientHeight / list.scrollHeight) * 100;
    thumb.style.height = `${thumbHeight}%`;
 
    thumb.style.top = `${(list.scrollTop / list.scrollHeight) * 100}%`;
  });
}
// Применить к Nice Select2

   setTimeout(() => {
    


     document.querySelectorAll('.nice-select .list').forEach(initCustomScrollbar);
    }, 500);



const carSwiper = document.querySelector('.car-swiper');
if (carSwiper) {
      var swiper = new Swiper(".car__swiper-thumbs", {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: true,
      watchSlidesProgress: true, pagination: {
                el: '.swiper-pagination-image',
                clickable: true,
            },
            navigation: {
                nextEl: '.car__swiper-thumbs-next',
                prevEl: '.car__swiper-thumbs-prev',
            },
    });
    var swiper2 = new Swiper(".car__swiper-big", {
      spaceBetween: 10,
  
      thumbs: {
        swiper: swiper,
      },
    });   

Fancybox.bind('[data-fancybox="gallery"]', {
    caption: function() { return ''; }
  // Your custom options for a specific gallery
});

}


    const swiperSimilar = document.querySelector('.similar__cars-swiper');
  
    if (swiperSimilar) {


        const swiperSimCars = new Swiper(swiperSimilar, {

        spaceBetween: 0,
      slidesPerView: 4,
       watchSlidesProgress: true, 
        resistanceRatio: 0, 
         preloadImages: false,
       lazy: {
        loadPrevNext: true,
    },   pagination: {
                el: '.swiper-pagination',
                clickable: true,
            },
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },

                  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
        
    },
    // when window width is >= 480px
  
    // when window width is >= 640px
    768: {
      slidesPerView: 3,
      spaceBetween: 10
    },
        992: {
      slidesPerView: 4,
      spaceBetween: 10
    }
  }

        });
   } 



const accordeon = document.querySelector('.accordeon');

if (accordeon) {
    document.querySelectorAll('.accordeon__title').forEach(listenAccordeon);
}

function listenAccordeon(item){
  item.addEventListener('click', () => {
    const parent =  item.closest('.accordeon');
    parent.classList.toggle('active');
    const content = parent.querySelector('.accordeon__content');
    content.classList.toggle('active');
    content.classList.add('fade-in')
  });


}








// Кешируем элементы один раз
const modal = document.querySelector('.modal');
const modalBg = document.querySelector('.modal__bg');
const body = document.querySelector('body');
const titleDiv = document.querySelector('.modal__title');
const descriptionDiv = document.querySelector('.modal__description');
const closeBtn = document.querySelector('.close');

// Функция открытия модалки
function showModal(title, message,params='') {
    titleDiv.textContent = title;
    descriptionDiv.textContent = message;
    modal.classList.add('active');
    modalBg.classList.add('active');
    body.classList.add('no-scroll');
}

// Функция закрытия модалки
function hideModal() {
    modal.classList.remove('active');
    modalBg.classList.remove('active');
    body.classList.remove('no-scroll');
}

// Вешаем обработчики один раз
closeBtn.addEventListener('click', hideModal);
modalBg.addEventListener('click', hideModal);



const modalCarBuyBack = document.querySelector('.car__buyback');
if (modalCarBuyBack) {



    modalCarBuyBack.addEventListener('click',function(){
            const params = [];
            params['formType'] = 'carAction';
        showModal('Оставить заявку на оценку и выкуп авто','Оставьте свои контакты и наш менеджер перезвонит Вам с выгодным предложением.');
     

    });


}


const callbacks = document.querySelectorAll('.call');

callbacks.forEach((el)=> {

el.addEventListener('click',()=> {
       const params = [];
            params['formType'] = 'callback';
showModal('Обратный звонок','Наши менеджеры перезвонят Вам в течении 5 минут',params);
});

});




const modalCars = document.querySelectorAll('.modal__car');

if (modalCars) {
    
    modalCars.forEach((el)=>{
        el.addEventListener('click',()=>{
            const parent = el.closest('.car__item');
            const carTitle = parent.querySelector('.car__item-title').innerText;
            const id = parent.getAttribute('data-id');
            const year = parent.getAttribute('data-year');

            const params = [];
            params['carID'] = id;
            params['formType'] = 'miniCard';
            const title = 'Подайте заявку на покупку ' + carTitle + ' ' + year +' г.в.';
            const message = 'В кредит на специальных условиях от ' + window.crеditRate + '%!';


            showModal(title,message,params)

        });

    });


}



function throttle(func, limit) {
    let lastFunc;
    let lastRan;
    return function() {
        const context = this;
        const args = arguments;
        if (!lastRan) {
            func.apply(context, args);
            lastRan = Date.now();
        } else {
            clearTimeout(lastFunc);
            lastFunc = setTimeout(function() {
                if ((Date.now() - lastRan) >= limit) {
                    func.apply(context, args);
                    lastRan = Date.now();
                }
            }, limit - (Date.now() - lastRan));
        }
    };
}

 const header = document.querySelector('header');
window.addEventListener('scroll', throttle(() => {
    const scrollY = window.scrollY;
    const favorite = document.querySelector('.bottom__header-favorites');
    
    if (scrollY > 100) {
        header.style.opacity = '0.95';
        favorite.style.display = 'flex';
        header.classList.add('fixed');
        header.style.transform = 'translateY(0)';
    } else {
        favorite.style.display = 'none';
        header.style.opacity = '1';
         header.classList.remove('fixed')
    }
}, 100)); // 

const debouncedBrandFilterCars = debounce(brandPageFilter, 1000);
function setupBrandPaginationListener() {
 
    const paginationContainer = document.querySelector('.filter__output-pagination'); 
    
    if (!paginationContainer) return;
    
    // Вешаем обработчик на контейнер
    paginationContainer.addEventListener('click', function(e) {
        // Проверяем, был ли клик по элементу пагинации
        const paginatorLink = e.target.closest('.page-link:not(.disabled)');
        
        if (!paginatorLink) return;
        
        e.preventDefault();
        
        // Получаем номер страницы
        const page = paginatorLink.textContent.trim();
        // console.log('Page clicked:', page);
            const currentPage = document.querySelector('input[name="page"]');
    currentPage.value = page;
        // Если нужно получить URL из ссылки
        const url = paginatorLink.href;
        // console.log('URL:', url);
        const el = document.querySelector('.js-filter-sort-button.active');

    debouncedBrandFilterCars(el);
        // loadCars();
    
    });
}


async function brandPageFilter(el) {
    const brand = document.querySelector('.brand-header-wrapp').getAttribute('data-id');
    const params = [];
    const sortBy = el.getAttribute('data-sort');
    const sort = el.getAttribute('data-order');
    let currentPage = 1; // Always reset to page 1 when sorting changes
    
    // Only keep the current page if we're not changing sort
    // if (!sortBy || sortBy === document.querySelector('.filter__sort.active').getAttribute('data-sort')) {
    if (sortBy ) {
        currentPage = document.querySelector('input[name="page"]').value;
    }

    let filterSort = el.getAttribute('data-order');

  

    clearBrandFilter();
    el.setAttribute('data-order', filterSort);
    el.classList.add('active');

    params['sortBy'] = sortBy;
    params['sort'] = filterSort;

    const form = new FormData();
    form.append('sortBy', params['sortBy']);
    form.append('sort', params['sort']);
    form.append('mileage', params['mileage']);
    form.append('brand', brand);
    form.append('page', currentPage);

    toggleLoader(true);

    try {
        const container = document.querySelector('.filter__output');
        const containerPgination = document.querySelector('.filter__output-pagination');

        container.innerHTML = '';
        containerPgination.innerHTML = '';

        const response = await fetch('/get-brand-cars-filter', {
            method: 'POST',
            body: form,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            }
        });

        const models = await response.json();
        toggleLoader(false);
        container.innerHTML = models.html;
        containerPgination.innerHTML = models.pagination_html;
        setupBrandPaginationListener();
        const totalModels = document.querySelector('.filter__count');

        changeCarsImages();
        if (models.html === '') {
            const notFound = document.createElement('div');
            const textnode = document.createTextNode("Извините, автомобилей, соответствующих заданным параметрам, не найдено");
            notFound.append(textnode);
            container.append(notFound);
        }

        if (!response.ok) {
            throw new Error('Ошибка сервера');
        }
    } catch (error) {
        console.error('Ошибка:', error);
    }
}


const brandFilter = document.querySelectorAll('.js-filter-sort-button');

function clearBrandFilter() {
      brandFilter.forEach((el)=>{
        el.setAttribute('data-order','');
      });
}


if (brandFilter) {
    clearBrandFilter();
    brandFilter.forEach((el)=>{

        el.addEventListener('click',function(){
            el.classList.add('active')
          const order =   el.getAttribute('data-order');

            if (order =='') {
                el.setAttribute('data-order','asc');
            }
            if (order == 'asc') {
                 el.setAttribute('data-order','desc');
            }
            if (order == 'desc') {
                 el.setAttribute('data-order','asc');
            }


brandPageFilter(el);

        });


    })
}



const creditFrom = document.querySelector('.credit__form');
const tradeinFrom = document.querySelector('.tradein__form');


if (creditFrom || tradeinFrom) {
  
    const complectSelect = document.querySelector(".compl-select");
    const bSelect = document.querySelector('.b-select');


  const niceComplect = new NiceSelect(complectSelect, {
            searchable: true,
            placeholder: "Автомобиль",
            searchtext: "Автомобиль",
            selectedtext: "Выбрано",
       
        });





bSelect.addEventListener('change', async function(){


                    const formData = new FormData();
                    formData.append('model',this.value);


                  const response = await fetch('/get-complects-by-name', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest', // Для Laravel (проверка isXmlHttpRequest)
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    }
                });

                if (!response.ok) {
                    throw new Error('Ошибка сервера');
                }

                const complects = await response.json();
                if (complects) {
                 complectSelect.innerHTML = '';   
            
                        complects.complects.forEach(opt => {
  const option = document.createElement('option');
  option.value = opt.id;
  option.textContent = opt.generation +' '+ opt.price + '₽ Лот № ' + opt.id;
                          
  complectSelect.appendChild(option);
}); 


   niceComplect.update();

                }
            });




complectSelect.addEventListener('change', async function(){



        const formData = new FormData();
        formData.append('id',this.value);

   const response = await fetch('/get-car-by-id', {
                    method: 'POST',
                    body: formData,
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest', // Для Laravel (проверка isXmlHttpRequest)
                        'Accept': 'application/json',
                        'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                    }
                });

                if (!response.ok) {
                    throw new Error('Ошибка сервера');
                }

                const car = await response.json();
                addCreditCar(car);
                addTradeinCar(car);
                
});

const slider1 = document.querySelector('.range-slider');
const slider2 = document.querySelector('.range-slider-next');






const monthSlider = document.querySelector('.range-slider');
const priceSlider = document.querySelector('.range-slider-next');
const carPriceElement = document.querySelector('.credit__car-price');
const creditElement = document.querySelector('.credit__car-credit');

function updateCreditInfo() {
    const months = monthSlider.querySelectorAll('.range-slider__thumb')[1].getAttribute('aria-valuenow');
    const initialPayment = priceSlider.querySelectorAll('.range-slider__thumb')[1].getAttribute('aria-valuenow');
    const carPrice = carPriceElement.innerText;
    
    creditElement.innerText = '';
    
    if (months == 0 || carPrice == '') {
        return false;
    }
    
    const creditArr = calculateLoan(carPrice, initialPayment, months);
    creditElement.append('от ' + formatPrice(creditArr.monthlyPayment) + '₽/мес');
}


if (slider1) {
    


const rangeSliderElement = RangeSlider(slider1, {
    step: 12,
    min: 0,
    max: 84,
    thumbsDisabled: [true, false],
    rangeSlideDisabled: true,
    value: [0, 48],
    onThumbDragEnd: updateCreditInfo
});

const rangeSliderElement2 = RangeSlider(slider2, {
    step: 200000,
    min: 0,
    max: 1000000,
    thumbsDisabled: [true, false],
    rangeSlideDisabled: true,
    value: [0, 600000],
    onThumbDragEnd: updateCreditInfo
});



const firstSliderParams = [
     12,
    24,
    36,
    48,
    60,
    72,
    84
];

const secondSliderParams = [
    '200 000₽',
    '400 000₽',
    '600 000₽',
    '800 000₽',
    '1 млн  ₽',
  
];




appendThumbsToSlider(slider1,firstSliderParams);
appendThumbsToSlider(slider2,secondSliderParams);


}


function appendThumbsToSlider(slider,params){
    const sliderWidth = slider.clientWidth;

    // const step = Math.round( sliderWidth / params.length);
    const step = (sliderWidth / params.length) - 1;
    let currentCursor = 0;

    for (let i = 0; i < params.length; i++) {
        let element = params[i];
      
       let thumb = document.createElement('div');
       let text = document.createElement('div');
        thumb.classList.add('slider-thumb');
        text.classList.add('slider-thumb-text');
        text.append(element);
          currentCursor = currentCursor + step;
        thumb.style.left = currentCursor +'px';
 if (i === params.length - 1) {
     text.style.left = (currentCursor - 15 )+'px';
  } else {
     text.style.left = (currentCursor - 5 )+'px';
  }
        
      

        slider.append(thumb)
        slider.append(text)



    }

}






const addCreditCar = (data)=> {
  
const title = document.querySelector('.credit__car-title');

if (!title) {
    return false;
}
const subtitle = document.querySelector('.credit__car-subtitle');

const price = document.querySelector('.credit__car-price');
const carId = document.querySelector('.car__id');
const image = document.querySelector('.credit__car-image');
const carIdBlock = document.querySelector('.car-id-block');
const credit = document.querySelector('.credit__car-credit');
const creditIcons = document.querySelector('.credit-icons');
const creditInfo1 = document.querySelector('.yellow_well');
const creditInfo2 = document.querySelector('.credit-form-text');


title.textContent = '';
subtitle.textContent = '';
credit.textContent = '';
price.textContent = '';
carId.textContent = '';
image.innerHTML = '';
const carimage = document.createElement('img'); 
carimage.setAttribute('src','/iwebp/' + data.car.id + '/' + data.image + '-xl.webp'); 
image.append(carimage);
carIdBlock.style.display = 'block';
carId.append(data.car.id);
price.append(data.discounts.formated.priceDiscount + '₽');
title.append(data.brand + ' ' + data.car.model + ' (' + data.car.year + 'г)' );
creditIcons.style.display = 'grid';
creditInfo1.style.display = 'flex';
creditInfo2.style.display = 'flex';

subtitle.append(data.car.transmission + ' / ' + data.car.engine_displacement + ' л / ' + data.car.horsepower + '  л.с. / ' + data.car.fuel_type  );



const showTechButton = document.querySelector('.credit__charachters');

showTechButton.addEventListener('click',function(){
showTech(data);
});


const valueOfMonths = document.querySelector('.range-slider').querySelectorAll('.range-slider__thumb');
const months = valueOfMonths[1].getAttribute('aria-valuenow');

const valuesOfPrice = document.querySelector('.range-slider-next').querySelectorAll('.range-slider__thumb');
const initialPayment  = valuesOfPrice[1].getAttribute('aria-valuenow');

const creditArr = calculateLoan(data.discounts.clear.priceDiscount,initialPayment,months)

credit.append('от ' + formatPrice(creditArr.monthlyPayment) + '₽/мес');

};

// Храним исходную цену машины вне функций, чтобы она сохранялась между вызовами
let currentCarPrice = 0;

// Общая функция для расчета финальной цены
function calculateFinalPrice(carPrice, userPriceInput) {
    const userPrice = returnOnlyNumbers(userPriceInput.value);
    const carPriceNum = returnOnlyNumbers(carPrice);
    let finalPrice = carPriceNum - userPrice;
    return finalPrice < 0 ? 0 : finalPrice;
}

// Обновляет цену в блоке
function updatePriceDisplay(priceElement, finalPrice) {
    if (!priceElement) return;
    priceElement.textContent = formatPrice(finalPrice);
}

// Обновляет цену при изменении ввода пользователя
function updateUserPriceOnline() {
    const priceBlock = document.querySelector('.tradein__car-info span');
    if (!priceBlock || !currentCarPrice) return; // Проверяем, что currentCarPrice установлен

    const userPriceInput = document.querySelector('input[name="user_price"]');
    const finalPrice = calculateFinalPrice(currentCarPrice, userPriceInput);
    
    updatePriceDisplay(priceBlock, finalPrice);
}

// Основная функция добавления машины
const addTradeinCar = (data) => {
    const image = document.querySelector('.tradein__car-image');
    const techno = document.querySelector('.tradein__car-techno');
    if (!image) return;
    const infoBlock = document.querySelector('.tradein__car');
    if (window.innerWidth >= 769) {
        infoBlock.style.display = 'flex';
    }
    else {
        infoBlock.style.display = 'block';
    }
  
    const userPriceInput = document.querySelector('input[name="user_price"]');
    const priceBlock = document.querySelector('.tradein__car-info span');

    // Сохраняем исходную цену машины
    currentCarPrice = data.discounts.clear.priceDiscount;

    // Удаляем старый обработчик (если был) и добавляем новый
    userPriceInput.removeEventListener('input', updateUserPriceOnline);
    userPriceInput.addEventListener('input', updateUserPriceOnline);
    const handleClick = () => showTech(data);
techno.removeEventListener('click', handleClick);

// Добавляем новый
techno.addEventListener('click', handleClick);
    // Рассчитываем и обновляем цену
    const finalPrice = calculateFinalPrice(currentCarPrice, userPriceInput);
    updatePriceDisplay(priceBlock, finalPrice);



    // Обновляем изображение
    image.innerHTML = '';
    const carImage = document.createElement('img');
    carImage.src = `/iwebp/${data.car.id}/${data.image}-xl.webp`;
    image.append(carImage);
};

let currentContainer = null;

function showTech(data) {
    

const techtable = `<div class="img-popup-body">
<div class="img-popup-params-column">
          <div class="img-popup-param">
            <div class="img-popup-param-name">Год выпуска</div>
            <div class="img-popup-param-value">` + data.car.year +`</div>
          </div>
          <div class="img-popup-param">
            <div class="img-popup-param-name">Пробег</div>
            <div class="img-popup-param-value">` + data.car.mileage +`</div>
          </div>
          <div class="img-popup-param">
            <div class="img-popup-param-name">Кузов</div>
            <div class="img-popup-param-value">` + data.car.body_type +`</div>
          </div>
          <div class="img-popup-param">
            <div class="img-popup-param-name">Цвет</div>
            <div class="img-popup-param-value">` + data.car.color +`</div>
          </div>
          <div class="img-popup-param">
            <div class="img-popup-param-name">Двигатель</div>
            <div class="img-popup-param-value">` + data.car.engine_displacement +` л / ` + data.car.horsepower +` л.с.</div>
          </div>
          <div class="img-popup-param">
            <div class="img-popup-param-name">Коробка</div>
            <div class="img-popup-param-value">` + data.car.transmission +`</div>
          </div>
          <div class="img-popup-param">
            <div class="img-popup-param-name">Тип топлива</div>
            <div class="img-popup-param-value">` + data.car.fuel_type +`</div>
          </div>
          <div class="img-popup-param">
            <div class="img-popup-param-name">Привод</div>
            <div class="img-popup-param-value">` + data.car.drive +`</div>
          </div>
          <div class="img-popup-param">
            <div class="img-popup-param-name">Владельцев</div>
            <div class="img-popup-param-value">` + data.car.owners +`</div>
          </div>
          <div class="img-popup-param">
            <div class="img-popup-param-name">ПТС</div>
            <div class="img-popup-param-value">` + data.car.pts +`</div>
          </div>
          <div class="img-popup-param">
            <div class="img-popup-param-name">Состояние</div>
            <div class="img-popup-param-value">` + data.car.condition +`</div>
          </div>
          <div class="img-popup-param">
            <div class="img-popup-param-name">Комплектация</div>
            <div class="img-popup-param-value">` + data.car.complectation +`</div>
          </div>
      </div>
      <div class="close"><svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" class="bi bi-x-circle" viewBox="0 0 16 16">
  <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16"></path>
  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708"></path>
</svg></div>
      </div>`;


      if (currentContainer) {
        currentContainer.remove();
        currentContainer = null;
    }
    
    // Создаем новый контейнер
    currentContainer = document.createElement('div');
    currentContainer.innerHTML = techtable;
    document.body.appendChild(currentContainer);
    modalBg.classList.add('active');
  
    const closeBtn = currentContainer.querySelector('.close');

    modalBg.addEventListener('click', function() {
        currentContainer.remove();
        currentContainer = null;
        modalBg.classList.remove('active');
    });
    
    closeBtn.addEventListener('click', function() {
        currentContainer.remove();
        currentContainer = null;
        modalBg.classList.remove('active');
    });

}




        };  //endif           



    const bankSlider = document.querySelector('.banks-swiper');
  
    if (bankSlider) {
  
        const swiper2 = new Swiper(bankSlider, {
            // Ваши настройки Swiper
            loop: false,
            slidesPerView: 5,
            speed: 400,
      spaceBetween: 20,
     
     
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
                  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 2,
        
    },
    // when window width is >= 480px
  
    // when window width is >= 640px
    768: {
      slidesPerView: 3,
      spaceBetween: 10
    },
        992: {
      slidesPerView: 5,
      spaceBetween: 10
    }
  }


        });


console.log(swiper2.autoplay.running);

    } 



// Add to favorite
// Add to favorite
// Add to favorite
// Add to favorite

  let favorites = JSON.parse(localStorage.getItem('favoriteCars')) || [];
            updateCounter();
            
            // Добавление обработчиков для всех кнопок избранного
            document.querySelectorAll('.favorite').forEach(button => {
                const carId = button.closest('.car__item').dataset.id;
            
                // Проверяем, добавлен ли уже автомобиль в избранное
                if (favorites.includes(carId)) {
                    button.classList.add('active');
                }
                
                button.addEventListener('click', function() {
                    const carId = this.closest('.car__item').dataset.id;
                    
                
                    if (favorites.includes(carId)) {
                        // Удаляем из избранного
                        favorites = favorites.filter(id => id !== carId);
                        this.classList.remove('active');
                       
                     

                    } else {
                        // Добавляем в избранное
                        favorites.push(carId);
                        this.classList.add('active');
                      
                    }
                    
                    // Сохраняем в localStorage
                    localStorage.setItem('favoriteCars', JSON.stringify(favorites));
                    updateCounter();

                 
                });
            });
            
            // Функция обновления счетчика
            function updateCounter() {



 const counters =  document.querySelectorAll('.counter');

                counters.forEach( el => {
      if (favorites.length > 0) {
                   
                    el.style.display = 'flex';
                      el.textContent = favorites.length;   
                }
                else {
el.style.display = 'none';
                }


                });

          
              
            }
async function getFavoriteCarsList() {
    // Проверяем, есть ли избранные автомобили
    if (favorites.length === 0) {
        console.log('Нет избранных автомобилей');
        return false;
    }

    try {
        // Получаем автомобили через AJAX
        const cars = await getFavoriteCarsByAjax();

        // Создаем контейнер для отображения
        const container = document.createElement('div');
        container.classList.add('favorite-container');
        
        // Проверяем, получили ли мы автомобили
        if (cars && cars.length > 0) {
            // Добавляем каждый автомобиль в контейнер
            cars.forEach(car => {
                const carElement = document.createElement('div');
                carElement.classList.add('favorite-car');
                carElement.classList.add('fade-in');
          
                carElement.innerHTML = `
                <div class="item">

                    <img src="${car.image}">
                    <div class="wrapper">
                    <h3><a href="${car.link}"> ${car.title}</a></h3>
                    <div class="title">${car.subtitle}</div>
                    <div class="fav-price">${car.discounts.formated.priceDiscount} </div>
                    </div>
                    <div class="remove" data-id=${car.id}><img src="/img/remove.svg"/></div>
                    </div>
                `;
                container.appendChild(carElement);
            });
            
            // Добавляем контейнер на страницу (или можно вернуть его)
            document.body.appendChild(container);
            return container;
        } else {
            console.log('Не удалось получить данные об автомобилях');
            return false;
        }
    } catch (error) {
        console.error('Ошибка при получении избранных автомобилей:', error);
        return false;
    }
}

// Добавление в избранное на странице авто
const carFavorite = document.querySelector('.car-favorite');
if (carFavorite) {
       const carId = carFavorite.getAttribute('data-id');

 if (favorites.includes(carId)) {
                    carFavorite.classList.add('active');
                }



        carFavorite.addEventListener('click',()=>{
      
                 // Проверяем, добавлен ли уже автомобиль в избранное
                 if (favorites.includes(carId)) {
                        // Удаляем из избранного
                        favorites = favorites.filter(id => id !== carId);
                        carFavorite.classList.remove('active');
                       
                     

                    } else {
                        // Добавляем в избранное
                        favorites.push(carId);
                        carFavorite.classList.add('active');
                      
                    }
                    
                    // Сохраняем в localStorage
                    localStorage.setItem('favoriteCars', JSON.stringify(favorites));
                    updateCounter();
                
        });

}


// Обработчики для кнопок показа избранного
const favoritesShowBut = document.querySelectorAll('.show-favorite');
favoritesShowBut.forEach(el => {
    el.addEventListener('click', async () => {
        // Проверяем, есть ли уже открытый список
        const existingContainer = document.querySelector('.favorite-container');
        
        if (existingContainer) {
            // Если контейнер уже есть - удаляем его
            existingContainer.remove();
            // Меняем текст кнопки (опционально)
            el.textContent = 'Избранное';
        } else {
            // Если контейнера нет - создаем новый
            el.textContent = 'Избранное'; // Опционально меняем текст
            await getFavoriteCarsList();
        }
    });
});

// AJAX-запрос для получения автомобилей
async function getFavoriteCarsByAjax() {
    try {
        const formData = new FormData();
        // Преобразуем массив favorites в строку для отправки
        formData.append('favorites', favorites);

        const response = await fetch('/get-favorite-cars', {
            method: 'POST',
            body: formData,
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
                'Accept': 'application/json',
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
            }
        });

        if (!response.ok) {
            throw new Error(`Ошибка сервера: ${response.status}`);
        }

        const data = await response.json();
        return data.cars || []; // Возвращаем массив автомобилей или пустой массив
    } catch (error) {
        console.error('Ошибка в getFavoriteCarsByAjax:', error);
        throw error; // Пробрасываем ошибку дальше
    }
}





document.addEventListener('click', function(event) {
    // Проверяем, был ли клик по кнопке удаления или её потомкам
    const removeBtn = event.target.closest('.remove');
    if (!removeBtn) return;
    
    // Получаем ID автомобиля
    const carId = removeBtn.dataset.id;
    
    // Удаляем из localStorage
    removeFromFavorites(carId);
    
    // Находим родительский элемент автомобиля
    const carElement = removeBtn.closest('.favorite-car');
    
    // Анимация удаления
    carElement.classList.add('fade-out');
    setTimeout(() => {
        carElement.remove();
        updateFavoriteCounter();
        // Если контейнер пуст - скрываем его
        if (!document.querySelector('.favorite-car')) {
            document.querySelector('.favorite-container').remove();
        }
    }, 100);
});

function removeFromFavorites(carId) {
    try {
        let favorites = JSON.parse(localStorage.getItem('favoriteCars')) || [];
        favorites = favorites.filter(id => id !== carId.toString()); // Преобразуем в строку для сравнения
        localStorage.setItem('favoriteCars', JSON.stringify(favorites));
    } catch (e) {
        console.error('Ошибка при удалении из избранного:', e);
    }
}

// Функция обновления счетчика
function updateFavoriteCounter() {
    const favorites = JSON.parse(localStorage.getItem('favoriteCars')) || [];
    const counter = document.querySelectorAll('.counter');
    if (counter) {
        counter.forEach(el => {

                el.textContent= favorites.length;

        } )
     
    }
}






// function clearActiveSortClasses() {
//     commonFilterButtons.forEach(btn => {
//         btn.classList.remove('active');
//     });
// }



// async function commonFilter(el) {
//     const container = document.querySelector('.common-filter');
//     const type = container.getAttribute('data-type');
//     const value = container.getAttribute('data-value');
//     const sortBy = el.getAttribute('data-sort');
//     const sort = updateSortButtons(el);
    
//     const form = new FormData();
//     form.append('sortBy', sortBy);
//     form.append('sort', sort);
//     form.append('page', 1); // Всегда сбрасываем на первую страницу
//     form.append('type', type);
//     form.append('value', value);

//     try {
//         toggleLoader(true);
//         const response = await fetch('/get-common-filter', {
//             method: 'POST',
//             body: form,
//             headers: {
//                 'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
//                 'X-Requested-With': 'XMLHttpRequest'
//             }
//         });

//         if (!response.ok) throw new Error('Ошибка сервера');
        
//         const data = await response.json();
//         setupCommonPaginationListener();
//         document.querySelector('.cars__container').innerHTML = data.html || 
//             '<div>Извините, автомобилей не найдено</div>';
        
//     } catch (error) {
//         console.error('Ошибка:', error);
//     } finally {
//         toggleLoader(false);
//     }
// }

// Инициализация






// const debouncedcommonFilter = debounce(commonFilter, 1000);
// function setupCommonPaginationListener() {
 
//     const paginationContainer = document.querySelector('.filter__output-pagination'); 
    
//     if (!paginationContainer) return;
    
//     // Вешаем обработчик на контейнер
//     paginationContainer.addEventListener('click', function(e) {
//         // Проверяем, был ли клик по элементу пагинации
//         const paginatorLink = e.target.closest('.page-link:not(.disabled)');
        
//         if (!paginatorLink) return;
        
//         e.preventDefault();
        
//         // Получаем номер страницы
//         const page = paginatorLink.textContent.trim();
//         // console.log('Page clicked:', page);
//             const currentPage = document.querySelector('input[name="page"]');
//     currentPage.value = page;
//         // Если нужно получить URL из ссылки
//         const url = paginatorLink.href;
//         // console.log('URL:', url);
//         const el = document.querySelector('.common-filter.active');
//         console.log(el)
//         console.log(currentPage)
//     debouncedcommonFilter(el);
//         // loadCars();
    
//     });
// }



















const commonFilterButtons = document.querySelectorAll('.common-filter-but');

if (commonFilterButtons.length) {
    commonFilterButtons.forEach(btn => {
        btn.addEventListener('click', function() {
            const carsContainer = document.querySelector('.cars__container');
            carsContainer.innerHTML = '';
        updateSortButtons(btn)
            commonFilter(this);
        });
    });
}
 

function clearActiveSortClasses() {
    commonFilterButtons.forEach(btn => {
        btn.classList.remove('active');
     
    });
}

function updateSortButtons(clickedButton) {
    clearActiveSortClasses();
    clickedButton.classList.add('active');
    
    const currentOrder = clickedButton.getAttribute('data-order') || '';
    let newOrder = 'asc';
    
    if (currentOrder === 'asc') {
        newOrder = 'desc';
    } else if (currentOrder === 'desc') {
        newOrder = 'asc';
    }
    
    clickedButton.setAttribute('data-order', newOrder);
    return newOrder;
}


// Обработчик для пагинации
function setupCommonPaginationListener() {
    document.addEventListener('click', function(e) {
        const paginatorLink = e.target.closest('.page-link');
        
        if (!paginatorLink || paginatorLink.classList.contains('disabled') || !paginatorLink.href) return;
        
        e.preventDefault();
        
        // Извлекаем номер страницы из URL
        const url = new URL(paginatorLink.href);
        const page = url.searchParams.get('page') || 1;
        
        // Обновляем скрытое поле с текущей страницей
        document.querySelector('input[name="page"]').value = page;
        
        // Получаем активный элемент сортировки
        const activeFilter = document.querySelector('.common-filter-but.active');
        
        // Вызываем фильтрацию
        commonFilter(activeFilter);
    });
}

// Обновите функцию commonFilter для поддержки пагинации
async function commonFilter(el) {
    const container = document.querySelector('.common-filter');
    const type = container.getAttribute('data-type');
    const value = container.getAttribute('data-value');
    const sortBy = el.getAttribute('data-sort');
    const sort = el.getAttribute('data-order');

    const page = document.querySelector('input[name="page"]').value || 1;
    console.log(sort)
    const form = new FormData();
    if (sortBy) form.append('sortBy', sortBy);
    if (sort) form.append('sort', sort);
    form.append('page', page);
    form.append('type', type);
    form.append('value', value);

    try {
        toggleLoader(true);
        const response = await fetch('/get-common-filter', {
            method: 'POST',
            body: form,
            headers: {
                'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
                'X-Requested-With': 'XMLHttpRequest'
            }
        });

        const data = await response.json();
        document.querySelector('.cars__container').innerHTML = data.html;
        document.querySelector('.pagination-container').innerHTML = data.pagination_html;
        
        // После обновления контента переинициализируем обработчик
        setupCommonPaginationListener();
        
    } catch (error) {
        console.error('Ошибка:', error);
    } finally {
        toggleLoader(false);
    }
}



const frontButtons = document.querySelector('.link__buttons');


if (frontButtons) {
      var swiper = new Swiper(frontButtons, {
      spaceBetween: 10,
      slidesPerView: 4,
      freeMode: false,
      watchSlidesProgress: true,
         pagination: {
                el: '.buttons-pagination',
                clickable: true,
            },
      breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
        
    },
    // when window width is >= 480px
  
    // when window width is >= 640px
    768: {
      slidesPerView: 3,
      spaceBetween: 10
    },
        992: {
      slidesPerView: 4,
      spaceBetween: 10
    }
  }
    });
}

const mobileMenu = document.querySelector('.bottom__header');

const hamburger = document.querySelector('.hamburger');
hamburger.addEventListener('click',()=> {
hamburger.classList.toggle('active');
mobileMenu.classList.toggle('active');

});



const footerItem = document.querySelectorAll('.footer-item .title');

footerItem.forEach(ctx => {
ctx.addEventListener('click',()=>{
    ctx.classList.toggle('active');
console.log(1);

const parent = ctx.closest('.footer-item');

const list = parent.querySelector('.list-unstyled');
    list.classList.toggle('active');


});



});



const showCatalog = document.querySelector('.block__catalog-show');

if (showCatalog) {

        const catalogContainer = document.querySelector('.block__catalog');

        showCatalog.addEventListener('click', ()=>{
            catalogContainer.classList.toggle('active');
            if (showCatalog.innerText == 'Показать все') {
                showCatalog.innerText = 'Свернуть';
                catalogContainer.style.height = 'auto';
            }
            else {
                 showCatalog.innerText = 'Показать все';
                    catalogContainer.style.height = '150px';
            }

      


        });

}






 const siperServices = document.querySelector('.swiper-service');

    if (siperServices) {


        const swiperServices = new Swiper(siperServices, {

        spaceBetween: 0,
      slidesPerView: 4,
       watchSlidesProgress: true, 
        resistanceRatio: 0, 

   pagination: {
                el: '.service-pagination',
                clickable: true,
            },

         lazy: {
        loadPrevNext: true,
    },

                  breakpoints: {
    // when window width is >= 320px
    320: {
      slidesPerView: 1,
        
    },
    // when window width is >= 480px
  
    // when window width is >= 640px
    768: {
      slidesPerView: 3,
      spaceBetween: 10
    },
        992: {
      slidesPerView: 4,
      spaceBetween: 10
    }
  }

        });
   } 






// Отправка формы



function validatePhone(phone) {
  const cleaned = phone.replace(/\D/g, '');
  return cleaned.length === 11 && (cleaned[0] === '7' || cleaned[0] === '8');
}


// Функция проверки наличия Comagic
function isComagicAvailable() {
  return typeof window.Comagic !== 'undefined' && 
         typeof window.Comagic.addOfflineRequest === 'function';
}

// Модифицированная функция отправки
async function sendToComagic(formData, formElement) {
  if (!isComagicAvailable()) {
    console.log('Comagic не доступен, пропускаем отправку');
    return true; // Возвращаем true, чтобы не прерывать основной поток
  }

  const comagicData = {
    phone: formData.get('phone'),
    name: formData.get('name') || '',
    form_name: formElement.getAttribute('data-type') || 'Форма с сайта',
    message: Array.from(formData.entries())
      .filter(([key]) => !['phone', 'name', '_token'].includes(key))
      .map(([key, value]) => `${key}: ${value}`)
      .join('\n')
  };

  return new Promise((resolve) => {
    window.Comagic.addOfflineRequest(comagicData, function(o) {
      if (o instanceof XMLHttpRequest) {
        o = JSON.parse(o.response);
      }
      resolve(o.success);
    });
  });
}

  let metrikaCounterId = '';
 if (typeof ym === 'function') {
       metrikaCounterId = Number(Object.keys(window).find(key => 
    key.startsWith('yaCounter')
)?.replace('yaCounter', ''));
// console.log('ID счётчика Яндекс.Метрики:', metrikaCounterId);

    } else {
        // Счетчик не установлен или произошла ошибка
        console.log("Счетчик Яндекс.Метрики не найден");
    }





// Модифицированная handleFormSubmit
async function handleFormSubmit(e) {
  e.preventDefault();
  
  const form = e.target;

  const policy = form.querySelector('input[name="policy"]');
  const label = form. querySelector('.checkmark');
    const errorMsg = form.querySelector('.error-message');
  if (!policy.checked) {
     errorMsg.style.display = 'block';
    label.classList.add('highlight-animation');
       setTimeout(() => {
        label.classList.remove('highlight-animation');
      }, 1500);
     return false;
  }

  const phoneInput = form.querySelector('input[name="phone"]');
  const submitButton  = form.querySelector('button');
  const phone = phoneInput.value;
  phoneInput.style.border = '1px solid #e8e8e8';

  if (!validatePhone(phone)) {
    if (phoneInput.errorTimeout) {
      clearTimeout(phoneInput.errorTimeout);
    }
    
    phoneInput.errorTimeout = setTimeout(() => {
      phoneInput.style.border = '1px solid red';
    }, 300);
    return false;
  }

    submitButton.disabled = true;
    submitButton.innerHTML = 'Отправка';

  const type = form.getAttribute('data-type') || '';
  const formData = new FormData(form);
  formData.append('type', type);

  try {
    // Создаем массив промисов
    const promises = [
      fetch("/sendform", {
        method: "POST",
        body: formData,
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/json',
          'X-CSRF-TOKEN': document.querySelector('meta[name="csrf-token"]').content,
        }
      })
    ];

    // Добавляем Comagic только если он доступен
    if (isComagicAvailable()) {
      promises.push(sendToComagic(formData, form));
    }

    const [serverResponse, comagicResponse] = await Promise.all(promises);
    
    if (!serverResponse.ok) throw new Error("Ошибка сервера");
    
    const result = await serverResponse.json();
    form.reset();
    
    // Учитываем что comagicResponse может быть undefined
    const successMessage = comagicResponse === false 
      ? 'Заявка принята, но возникла проблема с системой уведомлений. Мы вам перезвоним.'
      : 'Спасибо! Заявка отправлена. В ближайшее время с Вами свяжется менеджер.';
    
    showMessage(successMessage);
    // if (metrikaCounterId) {
        // ym(metrikaCounterId,'reachGoal','form_send');
 ym(92719302,'reachGoal','form_send')
    // }


  } catch (error) {
    console.error("Ошибка:", error);
    showMessage('Ошибка отправки формы! Пожалуйста, попробуйте позже.');
  } finally {
    // В любом случае разблокируем кнопку и убираем прелоадер
    submitButton.disabled = false;
    submitButton.textContent = 'Отправить';
  }
}

// Инициализация форм
const forms = document.querySelectorAll('.sendform');
if (forms) {
  forms.forEach(form => {
    form.addEventListener("submit", handleFormSubmit);
  });
}

function showMessage(message, type = 'success') {
  // Создаем элементы
  const messageContainer = document.createElement('div');
  const messageTitle = document.createElement('div');
  const messageBg = document.createElement('div');
  
  // Добавляем классы
  messageContainer.className = `show__message show__message--${type}`;
  messageTitle.className = 'show__message-title';
  messageBg.className = 'show__message-bg';
  
  // Устанавливаем текст
  messageTitle.textContent = message;
  
  // Собираем структуру
  messageContainer.appendChild(messageTitle);
  
  // Добавляем в body
  document.body.appendChild(messageContainer);
  document.body.appendChild(messageBg);
  
  // Автоматическое закрытие через 5 секунд
//   setTimeout(() => {
//     messageContainer.remove();
//     messageBg.remove();
//   }, 5000);
  
    if (modal.classList.contains('active')) {
     hideModal();
    }


  // Закрытие по клику на фон
  messageBg.addEventListener('click', () => {
    messageContainer.remove();
    messageBg.remove();
  });
}

const showCar = document.querySelector('.car__top');

if (showCar) {
document.querySelectorAll('.car__top-check input[type="checkbox"]').forEach(checkbox => {
  const priceContainer = document.querySelector('.car__top-price');
  const priceElement = checkbox.closest('.car__top-check').querySelector('.text span');
  
 const optionPrice = parseInt(priceElement.innerText.replace(/\D/g, ''), 10);
  
 const initialPrice = parseInt(priceContainer.innerText.replace(/\D/g, ''), 10);
  


  checkbox.addEventListener('change', function() {
    const currentPrice = parseInt(priceContainer.innerText.replace(/\D/g, ''), 10);
    
    if (this.checked) {
      priceContainer.innerText = (currentPrice - optionPrice).toLocaleString();
    } else {
      priceContainer.innerText = (currentPrice + optionPrice).toLocaleString();
    }
  });
});

}

const ifCarPageButtons = document.querySelectorAll('.car__show-buttons div');
if (ifCarPageButtons.length > 0) {
        const title = document.querySelector('h1').innerText;
        const currentUrl = window.location.href;
        const messageToForm = title + ' | Сайт: ' + currentUrl;
        const form = document.querySelector('.modal .sendform');
        const inputMessage = document.createElement('input');
        inputMessage.type = 'hidden'; 
        inputMessage.name = 'message'; 
        inputMessage.value = messageToForm;

        form.appendChild(inputMessage);
  



      ifCarPageButtons.forEach((ctx)=>{
   ctx.addEventListener('click', function(){
        const type = ctx.getAttribute('data-type');
        if (type=="credit") {
              showModal('Купить в кредит ' + title);
        } 
        else {
           showModal('Купить ' + title);
        }
    

    });


      });
  function animateElement(element) {
    element.classList.add('value-change');
    element.addEventListener('animationend', () => {
      element.classList.remove('value-change');
    }, {once: true});
  }

let hasAnimated = false;
function checkIfScrolledPast() {
     if (window.innerWidth <= 768) {
    const scrollEl = document.querySelector('.car__top-price');
    const elPos = scrollEl.getBoundingClientRect();
    const mobilePlate = document.querySelector('.car__plate');
 
    if (elPos.top <= 0) {
      
            mobilePlate.classList.add('active');
               if (!hasAnimated) {
                animateElement(mobilePlate);
                hasAnimated = true; // Устанавливаем флаг, что анимация выполнена
            }
    }
    else {
         mobilePlate.classList.remove('active');
          hasAnimated = false;
    }
  
     }
}

window.addEventListener('scroll', throttle(checkIfScrolledPast, 200));
const plateBut = document.querySelector('.car__plate-but');
plateBut.addEventListener('click',()=>{
   const title = document.querySelector('h1').innerText;
          showModal('Купить ' + title);


});


}



const frontPopularBrands = document.querySelector('.front-popular');
if (frontPopularBrands) {
    const brands = frontPopularBrands.querySelectorAll('.item');

brands.forEach(ctx => {
    ctx.addEventListener('click', (e) => {
        // Предотвращаем всплытие события, если нужно
        e.stopPropagation();
        
        // Убираем active у всех элементов
        brands.forEach(brand => {
            if (brand !== ctx) {
                brand.classList.remove('active');
            }
        });
        
        // Переключаем active у текущего элемента
        ctx.classList.toggle('active');
    });
});

document.addEventListener('click', () => {
    brands.forEach(brand => {
        brand.classList.remove('active');
    });
});


}



function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: 'smooth' // Плавная прокрутка
  });
}

function toggleBackToTopBtn() {
  const btn = document.querySelector('.to__top');
  if (window.scrollY > 300) {
    btn.classList.add('show');
  } else {
    btn.classList.remove('show');
  }
}
const debouncedToggle = throttle(toggleBackToTopBtn, 200);

document.querySelector('.to__top').addEventListener('click', scrollToTop);
window.addEventListener('scroll', debouncedToggle);

toggleBackToTopBtn();



 // Находим все инпуты, которые нужно модифицировать
function createFloatingPlaceholders(selector = 'input[placeholder]') {
  // Находим все элементы, которые нужно модифицировать
  const inputs = document.querySelectorAll(selector);
  
  inputs.forEach(input => {
    // Пропускаем элементы, которые уже обработаны
    if (input.closest('.placeholdertext')) return;
    
    // Создаём обёртку
    const wrapper = document.createElement('div');
    wrapper.className = 'placeholdertext';
    
    // Получаем текст из placeholder
    const placeholderText = input.getAttribute('placeholder');
    
    // Создаём span с текстом
    const span = document.createElement('span');
    span.className = 'ptext';
    span.textContent = placeholderText;
    
    // Вставляем инпут в обёртку
    input.parentNode.insertBefore(wrapper, input);
    wrapper.appendChild(input);
    
    // Добавляем span в обёртку
    wrapper.appendChild(span);
    
    // Обработчик событий для управления видимостью placeholder
    function updatePlaceholder() {
      span.style.display = input.value === '' ? 'none' : 'block';
    }
    
    // Инициализация и обработка событий
    updatePlaceholder();
    input.addEventListener('input', updatePlaceholder);
    input.addEventListener('focus', updatePlaceholder);
    input.addEventListener('blur', updatePlaceholder);
  });
}

createFloatingPlaceholders();





 function setCoockie() {
  const COOKIE_KEY = 'cookie_accepted';
    
    if (!localStorage.getItem(COOKIE_KEY)) {
        // Создаем уведомление
        const notification = document.createElement('div');
        notification.style.cssText = `
            position: fixed;
            bottom: 20px;
            right: 20px;
            background: #fff;
            padding: 15px 20px;
            border-radius: 8px;
            box-shadow: 0 2px 10px rgba(0,0,0,0.1);
            z-index: 9999;
             max-width: 400px;
            display: flex;
            gap: 15px;
            align-items: center;
            flex-wrap: wrap;
        `;
        
        notification.innerHTML = `
            <span style="font-size: 14px; color: #333;">
                🍪 Этот сайт использует cookie
            </span>
            <button id="acceptCookie" style="
                background: #13A582;
                color: white;
                border: none;
                padding: 5px 15px;
                border-radius: 4px;
                cursor: pointer;
            ">Принять</button>
        `;
        
        document.body.appendChild(notification);
        
        document.getElementById('acceptCookie').onclick = () => {
            localStorage.setItem(COOKIE_KEY, 'true');
            notification.remove();
        };
    }


}
setCoockie();

});









